import {
  fmtMeetingDate,
  meetingStatusLabel,
  meetingStatusTone,
  type Meeting,
} from '@entities/meetings';
import { DeletionBadge, deletionDaysLeft } from '../deletion';
import {
  Section,
  SectionHead,
  SectionLabel,
  ToggleBtn,
  MeetingList,
  MeetingRow,
  MeetingMain,
  MeetingTitle,
  MeetingMeta,
  StatusTag,
  EmptyHint,
} from './styles';

interface MeetingsListSectionProps {
  meetings: Meeting[];
  canDelete: boolean;
  showDeleted: boolean;
  onToggleDeleted: () => void;
  can_write: boolean;
}

export function MeetingsListSection({
  meetings,
  canDelete,
  showDeleted,
  onToggleDeleted,
  can_write,
}: MeetingsListSectionProps) {
  return (
    <Section>
      {canDelete ? (
        <SectionHead>
          <SectionLabel>Совещания</SectionLabel>
          <ToggleBtn
            type="button"
            $on={showDeleted}
            aria-pressed={showDeleted}
            onClick={onToggleDeleted}
          >
            {showDeleted ? 'Скрыть удалённые' : 'Показать удалённые'}
          </ToggleBtn>
        </SectionHead>
      ) : (
        <SectionLabel>Совещания</SectionLabel>
      )}
      {meetings.length > 0 ? (
        <MeetingList>
          {meetings.map((m) => {
            const daysLeft = m.deleted_at ? deletionDaysLeft(m.deleted_at) : null;
            return (
              <MeetingRow to={`/agents/meetings/meetings/${m.id}`} key={m.id}>
                <MeetingMain>
                  <MeetingTitle>{m.title}</MeetingTitle>
                  <MeetingMeta>{fmtMeetingDate(m.created_at)}</MeetingMeta>
                </MeetingMain>
                {m.deleted_at ? (
                  <DeletionBadge>
                    на удалении{daysLeft !== null ? ` · ${daysLeft} дн.` : ''}
                  </DeletionBadge>
                ) : (
                  <StatusTag $tone={meetingStatusTone(m.status)}>
                    {meetingStatusLabel(m.status)}
                  </StatusTag>
                )}
              </MeetingRow>
            );
          })}
        </MeetingList>
      ) : (
        <EmptyHint>
          Совещаний с вашим участием пока нет.{' '}
          {can_write ? 'Загрузите первую запись выше.' : 'Все поручения доступны во вкладке «Реестр».'}
        </EmptyHint>
      )}
    </Section>
  );
}
